export default "__VITE_ASSET___0o3Rboq__"